module.exports = __webpack_public_path__ + "e61e4b452015fd9e159b70e86086cb56.pdf";